import { render, staticRenderFns } from "./ModifyPopup.vue?vue&type=template&id=10a40cb5&scoped=true"
import script from "./ModifyPopup.vue?vue&type=script&lang=js"
export * from "./ModifyPopup.vue?vue&type=script&lang=js"
import style0 from "./ModifyPopup.vue?vue&type=style&index=0&id=10a40cb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a40cb5",
  null
  
)

export default component.exports